import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { t } from 'translation'

import HistoryModalList from 'components/HistoryModal/HistoryModalList'
import SettingsList from './SettingsList'
import SettingsLanguageSelect from './SettingsLanguageSelect'
import SettingsSaveFilesSelect from './SettingsSaveFilesSelect'
import SettingsPlaylist from './SettingsPlaylist'
import Modal from 'components/ui/Modal/Modal'
import PlayerTrainingVideo from 'components/VideoPlayer/VideoPlayer'
import LogoutModal from 'components/LogoutModal/LogoutModal'

import { getTrainingUrl } from 'utils/http'
import { accountsApi } from '../../api'
import { logOut } from 'store/actions'

import BackIcon from 'assets/back.png'

class SettingsModal extends Component {
  state = {
    isHistoryOpen: false,
    isLanguageSelectOpen: false,
    isSaveFilesSelectOpen: false,
    isPlaylistOpen: false,
    trainingVideoUrl: null,
    isLogoutOpen: false,
  }

  closeSubsettingTimeout = null

  trainingVideoElement = null
  closeImmersiveButton = null

  settingsLinks = [
    {
      title: t('settings.ABOUT_MUSIC_CARE'),
      href: t('links.ABOUT_MUSIC_CARE'),
    },
    {
      title: t('settings.TERMS'),
      href: this.props.isDoctor
        ? t('links.TERMS_DOCTOR')
        : this.props.isPro
        ? t('links.TERMS_PRO')
        : t('links.TERMS_PATIENT'),
    },
    {
      title: t('settings.PRIVACY'),
      href: t('links.PRIVACY'),
    },
    {
      title: t('settings.ACCOUNT'),
      href: t('links.ACCOUNT'),
    },
  ]

  closeSubsettingHandler = (e) => {
    if (e) e.stopPropagation()
    this.setState({
      isHistoryOpen: false,
      isLanguageSelectOpen: false,
      isSaveFilesSelectOpen: false,
      isPlaylistOpen: false,
      isLogoutOpen: false,
    })
  }

  openHistoryHandler = (e) => {
    if (e) e.stopPropagation()
    this.setState({ isHistoryOpen: true })
  }

  openLanguageSettingHandler = (e) => {
    if (e) e.stopPropagation()
    this.setState({ isLanguageSelectOpen: true })
  }

  openSaveFilesScreenHandler = (e) => {
    if (e) e.stopPropagation()
    this.setState({ isSaveFilesSelectOpen: true })
  }

  openPlaylistHandler = (e) => {
    if (e) e.stopPropagation()
    this.setState({ isPlaylistOpen: true })
  }

  closeModalHandler = (e) => {
    e.stopPropagation()
    this.props.toggleSettingsHandler()

    // Since fade out animation of modal takes 0.3,
    // if history or language settings are open, close them after fade completes
    this.closeSubsettingTimeout = setTimeout(() => this.closeSubsettingHandler(), 600)
  }

  toggleLogoutHandler = (e) => {
    if (e) e.stopPropagation()

    this.setState({ isLogoutOpen: true })
  }

  logOutHandler = async (e) => {
    e.stopPropagation()
    if (this.props.isPro && !this.props.isDoctor) {
      this.toggleLogoutHandler()
    } else this.props.logOut()
  }

  attachCloseImmersiveBtnRef = (btn) => (this.closeImmersiveButton = btn)

  attachTrainingVideoRef = (videoEl) => {
    if (videoEl) videoEl.addEventListener('ended', (e) => this.closeVideoHandler(e, true))
    this.trainingVideoElement = videoEl
  }

  watchVideoHandler = () => {
    const fileName = 'ANIM_PRESENTATION_MC_V2_300621.mp4'
    const trainingVideoUrl = getTrainingUrl(fileName)

    this.setState({ trainingVideoUrl }, () => this.trainingVideoElement.play())
  }

  closeVideoHandler = (e) => {
    if (e) e.stopPropagation()
    if (this.trainingVideoElementt) {
      if (!this.trainingVideoElement.paused) this.trainingVideoElement.pause()

      this.trainingVideoElement.removeEventListener('ended', (e) =>
        this.closeVideoHandler(e, true)
      )
    }
    this.setState({ trainingVideoUrl: null })
  }

  componentWillUnmount() {
    if (this.closeSubsettingTimeout) clearTimeout(this.closeSubsettingTimeout)
  }

  render() {
    return (
      <Modal show={this.props.areSettingsOpen} clicked={this.closeModalHandler}>
        <div
          className={`popup ${
            this.state.isSaveFilesSelectOpen || this.state.isPlaylistOpen
              ? 'save_files_mod'
              : this.state.isHistoryOpen
              ? 'history_mod'
              : ''
          }`}
        >
          {/* Show back to settings button if history or language subsetting is open */}
          {(this.state.isHistoryOpen || this.state.isLanguageSelectOpen) && (
            <button
              className="top_btn left_mod save_files_mod"
              onClick={this.closeSubsettingHandler}
            >
              <img
                className="top_btn_img back_mod"
                src={BackIcon}
                alt="Back to settings"
              />
            </button>
          )}
          {!this.state.isHistoryOpen && (
            <button
              className="close_btn right_pos_mod"
              onClick={this.closeModalHandler}
            ></button>
          )}
          {this.state.isHistoryOpen ? (
            <HistoryModalList />
          ) : this.state.isLanguageSelectOpen ? (
            <SettingsLanguageSelect
              closeLanguageSelectHandler={this.closeSubsettingHandler}
            />
          ) : this.state.isSaveFilesSelectOpen ? (
            <SettingsSaveFilesSelect
              closeSaveFilesSelectHandler={this.closeSubsettingHandler}
              closeModalHandler={this.closeModalHandler}
            />
          ) : this.state.isPlaylistOpen ? (
            <SettingsPlaylist
              closePlaylistHandler={this.closeSubsettingHandler}
              closeSettingsHandler={this.props.toggleSettingsHandler}
            />
          ) : this.state.isLogoutOpen ? (
            <LogoutModal closeLogoutHandler={this.closeSubsettingHandler} />
          ) : (
            <SettingsList
              logOutHandler={this.logOutHandler}
              openHistoryHandler={this.openHistoryHandler}
              openLanguageSettingHandler={this.openLanguageSettingHandler}
              openSaveFilesScreenHandler={this.openSaveFilesScreenHandler}
              openPlaylistHandler={this.openPlaylistHandler}
              openTrainingVideoHandler={this.watchVideoHandler}
              settingsLinks={this.settingsLinks}
            />
          )}
        </div>
        {this.state.trainingVideoUrl && (
          <PlayerTrainingVideo
            closeImmersiveVideoHandler={(e) => this.closeVideoHandler(e)}
            attachCloseImmersiveBtnRef={this.attachCloseImmersiveBtnRef}
            setVideoRef={this.attachTrainingVideoRef}
            videoUrl={this.state.trainingVideoUrl}
            loop={false}
            muted={false}
          />
        )}
      </Modal>
    )
  }
}

const mapStateToProps = ({ auth: { isPro, isDoctor } }) => ({ isPro, isDoctor })

const willMapDispatchToProps = {
  logOut,
}

export default connect(mapStateToProps, willMapDispatchToProps)(SettingsModal)

SettingsModal.propTypes = {
  areSettingsOpen: PropTypes.bool.isRequired,
  toggleSettingsHandler: PropTypes.func.isRequired,
}
